import type { ReactNode } from 'react';

export const symbol_missed_video_call: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M440-345q5-2 10-7l133-133q9-9 9-21.5t-9-21.5q-9-9-21.5-9t-21.5 9L429-417 306-540h60q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H230q-12.75 0-21.37 8.62Q200-582.75 200-570v130q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-60l148 148q5 5 10.13 7 5.14 2 11 2 5.87 0 10.87-2ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h520q24 0 42 18t18 42v215l134-134q7-7 16.5-3.46T880-649v338q0 9.92-9.5 13.46Q861-294 854-301L720-435v215q0 24-18 42t-42 18H140Zm0-60h520v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
